import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telefone'
})

export class TelefonePipe implements PipeTransform {

  transform(telefone: string): any {

    //console.log('>>>>>>>>> Telefone Pipe: ' + telefone);

    //return telefone;
    return '(' + telefone.substr(0,2) + ') ' + telefone.substr(2,5) + '-' + telefone.substr(7,4);

  }

}
